module.exports = __webpack_public_path__ + "static/media/519GriffinStNW_2018-06-05_6.31d704f2.jpg";